"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformingDeal = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
class TerraformingDeal extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.TERRAFORMING_DEAL,
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'P64',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('Each step you raise your TR, gain 2 M€.', (be) => be.tr(1).startEffect.megacredits(2));
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    static onTRIncrease(player) {
        if (!player.cardIsInEffect(CardName_1.CardName.TERRAFORMING_DEAL))
            return;
        player.addResource(Resources_1.Resources.MEGACREDITS, 2, { log: true });
    }
}
exports.TerraformingDeal = TerraformingDeal;
//# sourceMappingURL=TerraformingDeal.js.map